export default __webpack_public_path__ + "static/media/bet-and-earn-cn.57af60eb.gif";